<mat-dialog-content class="mat-typography" style="max-width: 500px">
    <div style="text-align: center">
      <webcam
        [height]="500"
        [width]="500"
        [trigger]="triggerObservable"
        (imageCapture)="handleImage($event)"
        *ngIf="showWebcam && !webcamImage"
        [allowCameraSwitch]="allowCameraSwitch"
        [switchCamera]="nextWebcamObservable"
        [videoOptions]="videoOptions"
        [imageQuality]="1"
        (cameraSwitched)="cameraWasSwitched($event)"
        (initError)="handleInitError($event)"
      >
      </webcam>
  
      <div
        class="snapshot"
        *ngIf="webcamImage"
        style="text-align: center; width: 100%"
      >
        <img
          [src]="webcamImage.imageAsDataUrl"
          style="width: 500px; height: auto"
        />
      </div>
  
      <br />
      <button
      class="btnEspaciado"
        mat-button
        mat-flat-button
        color="primary"
        type="button"
        *ngIf="!webcamImage"
        (click)="triggerSnapshot()"
      >
        Tomar foto
      </button>
      <button
      class="btnEspaciado"
        mat-button
        mat-flat-button
        color="warn"
        type="button"
        *ngIf="webcamImage"
        (click)="reintentarFoto()"
      >
        Tomar otra foto
      </button>
<!--       <button
      class="btnRedondeado"
        mat-button
        mat-flat-button
        color="accent"
        type="button"
        *ngIf="!webcamImage"
        (click)="toggleWebcam()"
      >
        Cambiar Camara
      </button> -->
    </div>
  
    <button
      *ngIf="webcamImage"
      class="btnGuardarRedondeado"
      mat-button
      mat-flat-button
      color="primary"
      type="button"
      (click)="aceptarFoto()"
    >
      Aceptar
    </button>
  
    <button mat-button mat-flat-button type="button" (click)="cancelar()">
      Cerrar
    </button>
  </mat-dialog-content>
  